import React from 'react'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus, 
  faUpload, 
  faTrashAlt,
  faCirclePlus,
  faDownload, 
} from '@fortawesome/free-solid-svg-icons'
import SideBar from '../../SideBar'
import moment from 'moment';
import useAxiosPrivateSAI from '../../../hooks/useAxiosPrivateSAI'
import useAuth from '../../../hooks/useAuth'
import {toast} from 'sonner'

const Holidays = () => {
  const axios = useAxiosPrivateSAI()
  const { setShowLoader } = useAuth()
  const [policyData, setPolicyData] = useState(null)
  const formatDate = (dateStr) => moment(dateStr).format('YYYY-MM-DD');
  const [holidays, setHolidays] = useState({});
  const [isDraft, setIsDraft] = useState(false);
  const [insetDays, setInsetDays] = useState([])
  const [orgType, setOrgType] = useState(null)
  const getAcademicYears = () => {
    const currentMonth = moment().month()
    const currentYear = moment().year()
    const startYear = currentMonth >= 8 ? currentYear : currentYear - 1
  
    return [
      `${startYear - 1}-${startYear}`,
      `${startYear}-${startYear + 1}`,
      `${startYear + 1}-${startYear + 2}`,
    ]
  }
  const academicYears = getAcademicYears()
  const [selectedYear, setSelectedYear] = useState(academicYears[1])

  const holidayLabels = [
    { label: 'Autumn Half Term', key: 'autumn' },
    { label: 'Christmas Holiday', key: 'xmas' },
    { label: 'Spring Half Term', key: 'spring' },
    { label: 'Easter Holiday', key: 'easter' },
    { label: 'Summer Half Term', key: 'summerHalf' },
    { label: 'Summer Holiday', key: 'summer' },
  ]

  const fetchHolidays = async (orgType, academyId, year) => {
    try {
      setShowLoader(true)

      const response = await axios.get(
        `/api/holidays/ajax_get/${orgType}/${academyId}/${year}`
      );
      const data = response.data;
  
      setHolidays({
        autumn: {
          start: formatDate(data.autumn?.start_date),
          end: formatDate(data.autumn?.end_date),
        },
        xmas: {
          start: formatDate(data.xmas?.start_date),
          end: formatDate(data.xmas?.end_date),
        },
        spring: {
          start: formatDate(data.spring?.start_date),
          end: formatDate(data.spring?.end_date),
        },
        easter: {
          start: formatDate(data.easter?.start_date),
          end: formatDate(data.easter?.end_date),
        },
        summerHalf: {
          start: formatDate(data.summerHalf?.start_date),
          end: formatDate(data.summerHalf?.end_date),
        },
        summer: {
          start: formatDate(data.summer?.start_date),
          end: formatDate(data.summer?.end_date),
        },
      });
  
      setInsetDays(data.inset || []);
    } catch (error) {
      console.error('Error fetching holidays:', error);
    }
    setShowLoader(false)
  }

  useEffect(() => {
    const storedPolicy = JSON.parse(localStorage.getItem('policyData'))
    const storedOrg = JSON.parse(localStorage.getItem('orgType'))
    setPolicyData(storedPolicy)
    setOrgType(storedOrg)
  }, [])

  useEffect(() => {
    if (!policyData?.policy_id || !orgType?.type || !orgType?.id) return
    fetchHolidays(orgType.type, orgType.id, selectedYear)
  }, [selectedYear, policyData, orgType])

  const addInsetDay = () => {
    setInsetDays([...insetDays, { description: '', start_date: '' }]);
  }

  // const removeInset = (idx) => {
  //   setInsetDays(insetDays.filter((_, i) => i !== idx));
  // }

  const handleHolidayChange = async (key, field, value) => {
    const updated = {
      ...holidays,
      [key]: {
        ...holidays[key],
        [field]: value,
      },
    };
  
    setHolidays(updated);
  
    try {
      await axios.post(
        `/api/holidays/ajax_update/${orgType.type}/${orgType.id}`,
        {
          start: field === 'start' ? value : updated[key].start,
          end: field === 'end' ? value : updated[key].end,
          tagName: key,
          year: selectedYear,
          holiday_status: 'draft',
        }
      );
      setIsDraft(true);
      toast.success('Holidays submitted successfully.')
    } catch (error) {
      toast.error('Failed to update holiday: ' + error);
    }
  }


  const handleInsetChange = async (idx, field, value) => {
    const updated = [...insetDays];
    updated[idx][field] = value;
    setInsetDays(updated);
  
    const inset = updated[idx];
  
    try {
      await axios.post(`/api/holidays/ajax_update/${orgType.type}/${orgType.id}`, {
        id: inset.id || undefined,
        start: inset.start_date,
        description: inset.description,
        tagName: 'inset',
        year: selectedYear,
        holiday_status: 'draft',
      })

      setIsDraft(true);
    } catch (error) {
      toast.error('Failed to update inset day: ' + error);
    }
  }

  const submitHolidays = async () => {
    try {
      if (!orgType?.id) {
        console.warn("Organisation ID not found.");
        return;
      }
  
      setShowLoader(true)
      const response = await axios.post(`/api/submit/holidays`, {
        ids: [orgType.id]
      });
  
      if (response.data?.error === false) {
        await fetchHolidays(orgType.type, orgType.id, selectedYear);
        setIsDraft(false)
        toast.success('Holidays submitted successfully.')
      } else {
        setIsDraft(true)
        toast.error(response.data?.message || 'Something went wrong.')
      }
    } catch (error) {
      setIsDraft(true)
      toast.error('Failed to submit holidays:' + error)
    } finally {
      setShowLoader(false)
    }
  }
  
  const removeInset = async (id) => {
    try {
      const response = await axios.post(
        `/vapi/holidays/inset/${id}`)
  
      toast.success('Inset day removed')
      return response.data;
    } catch (error) {
      toast.error('Failed to delete inset day: ' + error);
      throw error;
    }
  }

  const resetHolidayStore = (schools) => {
    const ids = schools.map((school) => school.organization_id);
  
    axios
      .post('/api/holidays/reset/', { ids })
      .then((response) => {
        if (response.data === 'draft') {
        } else if (response.data === 'error') {
          setTimeout(() => {
            toast.error('Oops!', 'You have not committed any staff details yet', 'error');
          }, 500);
        } else if (!response.data.error) {
          window.location.reload()
        }

        setIsDraft(true);
      })
      .catch((error) => {
        console.error('Error resetting holiday store:', error);
      });
  }

  const mapHolidayNameToKey = (rawName = '') => {
    const name = rawName.toLowerCase().trim()

    // Half-terms
    if (name.includes('autumn') && name.includes('half')) return 'autumn'
    if (name.includes('spring') && name.includes('half')) return 'spring'
    if (name.includes('summer') && name.includes('half')) return 'summerHalf'

    // Full holidays
    if (name.includes('summer') && name.includes('holiday')) return 'summer'
    if (name.includes('spring') && name.includes('holiday')) return 'easter'
    if (name.includes('autumn') || name.includes('autumn')) return 'xmas'

    if (name === 'autumn holiday') return 'xmas'

    return null
  }
  
  const parseLARecordsToState = (records = [], year) => {
    const rows = records.filter(row => (row.academic_year || '').trim() === (year || '').trim())

    const next = {
      autumn: { start: '', end: '' },
      xmas:   { start: '', end: '' },
      spring: { start: '', end: '' },
      easter: { start: '', end: '' },
      summerHalf: { start: '', end: '' },
      summer: { start: '', end: '' },
    }

    rows.forEach(row => {
      const key = mapHolidayNameToKey(row.holiday)
      if (!key) return
      next[key] = {
        start: moment(row.start_date).format('YYYY-MM-DD'),
        end:   moment(row.end_date).format('YYYY-MM-DD'),
      }
    })

    return next
  }

  const applyLAHolidays = async (laRows) => {
    const next = parseLARecordsToState(laRows, selectedYear);
    setHolidays(next)
    setInsetDays([])
    setIsDraft(true)
  }

  const autofillLAHolidays = async () => {
    try {
      const orgType = JSON.parse(localStorage.getItem('orgType'))

      if (!orgType?.type || !orgType?.id) {
        toast.error('Missing organisation details.')
        return;
      }
      setShowLoader(true)
  
      const { data } = await axios.get(
        `/api/get-la-holidays/${orgType.type}/${orgType.id}`
      )
  
      const laHoliday = data?.data || [];
      if (!laHoliday || (Array.isArray(laHoliday) && laHoliday.length === 0)) {
        toast.error('No LA Holidays found for this borough.');
        return;
      }
  
      const filtered = laHoliday.filter(r => (r.academic_year || '').trim() === (selectedYear || '').trim())
      if (filtered.length === 0) {
        toast.error(`No LA holidays found for ${selectedYear}.`)
        return
      }

      await applyLAHolidays(laHoliday)
      toast.success('LA holidays applied.')

    } catch (error) {
      console.error('Could not fetch LA Holidays', error);
      toast.error('Failed to fetch LA Holidays. Please try again later.');
    } finally {
      setShowLoader(false);
    }
  }

  return (
    <div className="w-full">
      <div className="mb-8">
        <h3 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white text-center pt-6">
          Manage your Holidays
        </h3>
        <h4 className="text-lg font-medium text-white text-center">
          Welcome to your Staff Absence Portal. Here you can manage your school holidays. 
          <br />
          <p className="text-yellow-200 text-base font-semibold">
            Please enter the start and end dates of the school holidays for each term.
          </p>
        </h4>
      </div>
      <div className="flex flex-col lg:flex-row max-w-[90rem] mx-auto lg:space-x-6 mt-32">
        {/* Sidebar Card */}
        <SideBar active={'Dashboard'} />
        {/* Main Card Section */}
        <main className="w-full lg:w-4/5">
          {/* Action Buttons */}
          <div className="flex items-center justify-end space-x-4">
            <button
              onClick={submitHolidays}
              className="inline-flex items-center border border-white text-sas bg-white rounded-md overflow-hidden text-sm font-medium shadow"
            >
              <span className="px-4 py-2">Submit your Holidays</span>
              <span className="bg-sas text-white px-3 py-2">
                <FontAwesomeIcon icon={faPlus} />
              </span>
            </button>
            <button onClick={autofillLAHolidays}
              className="inline-flex items-center border border-white text-sas bg-white rounded-md overflow-hidden text-sm font-medium shdaow">
              <span className="px-4 py-2">Autofull LA Holidays</span>
              <span className="bg-sas text-white px-3 py-2">
                <FontAwesomeIcon icon={faDownload} />
              </span>
            </button>
          </div>
          {isDraft ? (  
            <div className='flex justify-end'>
              <div className="bg-orange-100 border border-orange-300 text-orange-800 px-4 py-2 rounded shadow text-sm my-4">
                Holidays have unsaved changes. 
                <button onClick={() => resetHolidayStore(false)} className="underline font-semibold hover:text-orange-600">Revert Changes</button>
              </div>
            </div>
          ) : (
            <div className='flex justify-end'>
              <div className="bg-green-100 border border-green-300 text-green-800 px-4 py-2 rounded shadow text-sm my-4">
                Holidays are up to date.
              </div>
            </div>
          )}
      
          {/* Tabs */}
          <div className="flex space-x-2 mt-4">
            {academicYears.map((year) => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                className={`px-4 py-2 rounded-t-md font-medium shadow-md border ${
                  year === selectedYear
                    ? 'bg-sas text-white border-sas'
                    : 'bg-white text-gray-700 border-white'
                }`}
              >
                {year}
              </button>
            ))}
          </div>

          {/* Holiday Form */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-0">
            {/* Left Column */}
            <div className="bg-white rounded-b-lg rounded-r-lg shadow-md p-6">
              <h4 className="font-semibold text-sas-dark mb-2 border-b pb-2">Holidays</h4>
              {holidayLabels.map(({ label, key }) => (
                <div key={key} className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                  <div className="grid grid-cols-2 gap-4">
                    <input
                      type="date"
                      value={holidays[key]?.start || ''}
                      onChange={(e) => handleHolidayChange(key, 'start', e.target.value)}
                      className="border border-sas rounded-md px-2 py-1 text-sm"
                    />
                    <input
                      type="date"
                      value={holidays[key]?.end || ''}
                      onChange={(e) => handleHolidayChange(key, 'end', e.target.value)}
                      className="border border-sas rounded-md px-2 py-1 text-sm"
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Column */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div  className="flex justify-between items-center  mb-2 border-b pb-2">
                <h4 className="font-semibold text-sas-dark">Additional Days</h4>
                <button type="button"
                onClick={addInsetDay} 
                className="inline-flex items-center border border-sas text-sas rounded-md overflow-hidden text-sm font-medium">
                  <span className="px-4 py-2">Add Inset Day</span>
                  <span className="bg-sas text-white px-3 py-2">
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                </button>
              </div>
              {insetDays.map((inset, idx) => (
                <div key={idx} className="flex items-center gap-2 mb-3">
                  <select
                    value={inset.description}
                    onChange={(e) =>
                      handleInsetChange(idx, 'description', e.target.value)
                    }
                    className="w-1/2 border  border-sas px-2 py-1 text-sm rounded h-8"
                  >
                    <option value="">Select Type</option>
                    <option value="Inset Day">Inset Day</option>
                    <option value="Religious Holiday">Religious Holiday</option>
                    <option value="Weather Closure">Weather Closure</option>
                    <option value="Other">Other</option>
                  </select>
                  <input
                    type="date"
                    value={inset.start_date}
                    onChange={(e) =>
                      handleInsetChange(idx, 'start_date', e.target.value)
                    }
                    className="w-1/2 border px-2 py-1 text-sm rounded border-sas"
                  />
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    onClick={() => removeInset(inset.id)}
                    className="text-red-500 cursor-pointer"
                  />
                </div>
              ))}
              <div>
              </div>
            </div>
            
          </div>
        </main>
      </div>
    </div>
  )
}

export default Holidays
